import {lazy, Suspense, useContext, useEffect, useState} from 'react';
import { Routes, Route, Link} from "react-router-dom";
import logo from './logo.png';
import './App.css';
import { Navbar, Container} from 'react-bootstrap';
import { Subscription } from 'rxjs';
import { GlobalContext } from './ContextProvider';
import { UserInfo } from './Models';

const Landing = lazy(() => import('./guest/Landing'));
const Cms = lazy(() => import('./guest/Cms'));
const ContactUs = lazy(() => import('./guest/ContactUs'));
const FaqComponent = lazy(() => import('./guest/Faq'));
const LoginPage = lazy(() => import('./guest/Login'));
const SignUpForm = lazy(() => import('./guest/SignUp'));
const CostBasisLanding = lazy(() => import('./restricted/CostBasisLanding'));

export interface SocialMedia {
  link: string;
  color: string;
  backGroundColor: string;
  faClassName: string;
}
interface Cms {
    id: string;
    title: string,
    slug: string,
    description: string
};
function App() {

  const ctx = useContext(GlobalContext);

  const [cms, setCMS] = useState<Cms>({} as Cms);
  const [socialMedias, setSocialMedias] = useState<SocialMedia[]>([] as SocialMedia[]);
  const [userInFo, setUserInFo] = useState<UserInfo | null>(null);

  useEffect(() => {

    if (!ctx) return;
      
      const cmsSubscription: Subscription = ctx.getOrLoadCMSRecord("copyright").subscribe({
        next: (resp: any) => {
          setCMS(resp as Cms);
        },
        error: (err: any) => {
        },
      });

      const socialMediaSubscription: Subscription = ctx.getOrLoadSocialMedia().subscribe({
        next: (resp: any) => {
          setSocialMedias(resp as SocialMedia[]);
        },
        error: (err: any) => {
        },
      });

      const userInFoSubscription: Subscription = ctx.getUserInfo().subscribe({
        next: (resp: any) => {
          setUserInFo(resp as UserInfo);
        },
        error: (err: any) => {
        },
      });

      return () => {
        socialMediaSubscription.unsubscribe();
        cmsSubscription.unsubscribe();
        userInFoSubscription.unsubscribe();
      };

  }, [ctx]);

  const logoutHandler = () => {
    ctx?.setUserInfo(null);
  }

  return (
    <>
      <Navbar expand="lg" className="navbar navbar-expand-lg theme-nav-bg position-absolute w-100">
        <Container fluid>
          <Link className='navbar-brand' to="/">
            <img style={{ height: "28px" }} src={logo}></img>
          </Link>
          <Navbar.Toggle aria-controls="nav" />   {/* required */}
          <Navbar.Collapse id="nav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link to="/about" className="nav-link">
                  <i aria-hidden="true" className="fa fa-info-circle"></i> About
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/terms-of-use" className="nav-link">
                  <i aria-hidden="true" className="fa fa-file-text"></i> Terms Of Use
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/faq" className="nav-link">
                  <i aria-hidden="true" className="fa fa-question-circle"></i> FAQs
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact-us" className="nav-link">
                  <i aria-hidden="true" className="fa fa-envelope"></i> Contact Us
                </Link>
              </li>
              {userInFo && (
                <>
                  <li className="nav-item">
                    <Link to="/cost-basis-landing" className="nav-link">
                      <i aria-hidden="true" className="fa fa-calculater"></i> Cost Basis
                    </Link>
                  </li>
                </>
              )}
            </ul>
            <form className="form-inline my-2 my-md-0">
              <input name="search" type="text" placeholder="Search" id="search" className="form-control"/>
            </form>
            <ul className="navbar-nav ms-auto">
              {userInFo ? (
                <>
                  <li className="nav-item">
                    <Link to="/" className="nav-link">
                      <i aria-hidden="true" className="fa fa-user"></i> {userInFo._username}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <button
                      className="nav-link btn btn-link"
                      onClick={logoutHandler}
                      style={{ textDecoration: "none" }}
                    >
                      <i aria-hidden="true" className="fa fa-sign-out"></i> Logout
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link to="/login" className="nav-link">
                      <i aria-hidden="true" className="fa fa-sign-in"></i> Login
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/sign-up" className="nav-link">
                      <i aria-hidden="true" className="fa fa-user"></i>  Sign Up
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </Navbar.Collapse>

        </Container>
      </Navbar>
      <div className="content-footer-managed">
          <div className="mb-3">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Landing/>} />
              <Route path="/about" element={<Cms slug={"about"}/>} />
              <Route path="/terms-of-use" element={<Cms slug={"terms-of-use"}/>} />
              <Route path="/faq" element={<FaqComponent/>}/>
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/sign-up" element={<SignUpForm />} />
              <Route path="/cost-basis-landing" element={<CostBasisLanding />} />
            </Routes>
          </Suspense>
        </div>
        <footer className="footer">
          <nav className="navbar navbar-dark bg-dark pb-0">
            <div className="container-fluid">
              <div className="col-md-4">
                <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link to="/about" className="nav-link">
                      About
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/terms-of-use" className="nav-link">
                      Terms Of Use
                      </Link>
                    </li>
                </ul>
              </div>
              <div className="col-md-4">
                <ul className="navbar-nav">
                  
                  <li className="nav-item">
                    <Link to="/faq" className="nav-link">
                    FAQs
                    </Link>
                  </li>
                  <li className="nav-item">
                      <Link to="/contact-us" className="nav-link">
                      Contact Us
                      </Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <span className="nav-link">Connect With Us</span>
                  </li>
                  <li className="nav-item social-link">
                      {socialMedias && socialMedias.map((item) => (
                          <a target={'_blank'} href={item.link} className="nav-link" style={{'backgroundColor':item.backGroundColor, 'color':item.color}}>
                            <i className={`fa ${item.faClassName}`}></i>
                          </a>
                      ))}
                  </li>
                </ul>
              </div>
            </div>
            <div className="container-fluid">
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={(e) => e.preventDefault()} dangerouslySetInnerHTML={{ __html: cms?.description ?? "" }}></a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4"></div>
            </div>
          </nav>
        </footer>
      </div>
    </>
  );
}

export default App;
